import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Компонент по аналогии с FlexFactor

import React from 'react';
export var FlexLayout = function FlexLayout(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? 'nowrap' : _ref$wrap,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'flex-start' : _ref$justify,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'stretch' : _ref$align,
    gap = _ref.gap,
    style = _ref.style,
    children = _ref.children,
    className = _ref.className;
  var containerStyle = _objectSpread({
    display: 'flex',
    flexDirection: direction,
    flexWrap: wrap,
    justifyContent: justify,
    alignItems: align,
    gap: typeof gap === 'number' ? "".concat(gap, "px") : gap
  }, style);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: containerStyle,
    "data-t-id": "layouts-FlexLayout"
  }, children);
};